import PageHeader from "../components/PageHeader";
import HireQADeveloperContent from "../components/Hire-QaTester-Content";

const HireQADeveloper = () => {
    return (
        <>
            <PageHeader pagetitle="QA Tester" breadcrumbMenu="Home" breadcrumbMenuActive="QA Tester" image="/images/qa-tester-banner.jpg" />
            <HireQADeveloperContent />
        </>
    )
}

export default HireQADeveloper;